import { render, staticRenderFns } from "./tutorForm.vue?vue&type=template&id=0b348e4a&scoped=true"
import script from "./tutorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tutorForm.vue?vue&type=style&index=0&id=0b348e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b348e4a",
  null
  
)

export default component.exports